import { CartCountResponse } from '~/api/services/shopping-cart-api/index.type'
import AxiosClient from '~/app/react-query/axios'

export const getCartCount = (): Promise<CartCountResponse> => {
  const axios = new AxiosClient()
  return axios.instance.get(`/api/common/cart/count`)
}
